import { render, staticRenderFns } from "./EmbedDialog.vue?vue&type=template&id=36178701&"
import script from "./EmbedDialog.vue?vue&type=script&lang=js&"
export * from "./EmbedDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/ddv-home/ddv-home/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36178701')) {
      api.createRecord('36178701', component.options)
    } else {
      api.reload('36178701', component.options)
    }
    module.hot.accept("./EmbedDialog.vue?vue&type=template&id=36178701&", function () {
      api.rerender('36178701', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/EmbedDialog.vue"
export default component.exports